import _ from 'underscore';
import { getComparedDateRanges } from '@bingads-webui/date-ranges';
import { DateRangePanelBase } from '../base/date-range-panel-base';

/**
 * The compared date range panel allows user to select the
 * date range to compare the data against.
 * @param {Function} [dateRangesAccessor] - The optional function to get compared date ranges
 * @param {Function} [enabledRangesPredicate] - The optional function to filter compared date ranges
 * @param {Date} today - The date for today to be used in calculating date ranges
 * @param {Object} i18n - The i18n component. It should have method formatDate for formatting
 * dates and getString for getting localized strings
 * @extends {DateRangePanelBase}
 */
export class ComparedDateRangePanel extends DateRangePanelBase {
  initialize(options) {
    super.initialize(options);
    this.dateRangesAccessor = this.options.dateRangesAccessor || getComparedDateRanges;
  }

  /**
   * Sets the state of the panels container
   * @param {Object} selection - The selected compared date range
   * @param {Date} selection.start - Primary range start date
   * @param {Date} selection.end - Primary range end date
   * @param {string} selection.key - Key for the primary range
   * @param {Object} primaryRange - The selected primary date range
   * @param {Date} primaryRange.start - Primary range start date
   * @param {Date} primaryRange.end - Primary range end date
   * @param {string} primaryRange.key - Key for the primary range
   * @param {string} primaryRange.key - Key for the primary range
   * @returns {ComparedDateRangePanel} this
   */
  setState({ selection, primaryRange }) {
    // if (primaryRange) {
    //   const oldPrimaryRange = this.model.get('primaryRange') || {};
    //   if (primaryRange.start !== oldPrimaryRange.start ||
    //       primaryRange.end !== oldPrimaryRange.end) {
    //     this.updateDateRanges(primaryRange, selection);
    //   }
    // }
    if (selection) {
      this.model.set({ selectedKey: selection.key });
    }
    this.updateDateRanges(primaryRange, selection);

    this.showDatePickersIfCustomSelected();
    return this;
  }

  onPrimaryRangeChanged(primaryRange) {
    const { dateRanges, selectedKey } = this.getState();
    this.updateDateRanges(primaryRange, dateRanges[selectedKey]);
  }

  /**
 * Update the date ranges that can be selected
 * @private
 * @param {Object} primaryRange - The selected primary date range
 * @param {Object} selection - The selected compared date range
 * @returns {undefined}
 */
  updateDateRanges(primaryRange, selection = {}) {
    const { today, i18n } = this.options;

    const newDateRanges = this.dateRangesAccessor({
      today,
      i18n,
      primaryRange,
      comparedCustomStart: selection.start,
      comparedCustomEnd: selection.end,
    });

    // Retain the existing custom date ranges
    _.extend(newDateRanges, _.pick(this.model.get('dateRanges') || {}, value => value.isCustom));

    this.model.set({ dateRanges: newDateRanges, primaryRange });
  }
}
